export default function PageHeader({ eyebrow, title, subtitle, image }) {
  return (
    <section
      data-testid="page-header"
      className="relative pt-32 md:pt-40 pb-20 md:pb-28 px-6 md:px-10 overflow-hidden bg-grid border-b border-white/5"
    >
      {image && (
        <div className="absolute inset-0 -z-10">
          <img src={image} alt="" className="w-full h-full object-cover opacity-25" />
          <div className="absolute inset-0 bg-gradient-to-r from-slate-950 via-slate-950/85 to-slate-950/60" />
          <div className="absolute inset-0 bg-radial-fade" />
        </div>
      )}
      <div className="max-w-7xl mx-auto w-full grid lg:grid-cols-12 gap-8 items-end">
        <div className="lg:col-span-8 reveal">
          {eyebrow && (
            <div className="text-[11px] tracking-[0.3em] uppercase text-cyan-400 font-mono mb-5">
              {eyebrow}
            </div>
          )}
          <h1 className="text-4xl sm:text-5xl lg:text-6xl tracking-tighter font-medium text-slate-50 leading-[1.05]">
            {title}
          </h1>
          {subtitle && (
            <p className="mt-6 max-w-2xl text-base md:text-lg text-slate-400 leading-relaxed">
              {subtitle}
            </p>
          )}
        </div>
        <div className="hidden lg:block lg:col-span-4 text-right">
          <div className="inline-flex items-center gap-2 px-3 py-1.5 border border-cyan-400/30 bg-cyan-400/5">
            <span className="h-1.5 w-1.5 bg-cyan-400 rounded-full pulse-dot" />
            <span className="text-[10px] uppercase tracking-[0.3em] text-cyan-200 font-mono">
              GenX · Since 2011
            </span>
          </div>
        </div>
      </div>
    </section>
  );
}
